import { all, fork } from 'redux-saga/effects';
import liteObjectsReducer from './liteObjects/reducer';
import liteObjectsSaga from './liteObjects/saga';
import operationsHistoryListFiltersReducer from './operationsHictoryListFilters/reducer';
import operationsHistoryReducer from './operationsHistory/reducer';
import operationsHistorySaga from './operationsHistory/saga';
import paymentReducer from './payment/reducer';
import pdfInfoReduser from './pdfInfo/reducer';
import pdfInfoSaga from './pdfInfo/saga';
import taxesReducer from './taxes/reducer';
import taxesSaga from './taxes/saga';
import judicialActsReducer from './judicialActs/reducer';
import judicialActsSaga from './judicialActs/saga';
import unexplainedPayments from './unexplainedPayments/reducer';
import unexplainedPaymentsSaga from './unexplainedPayments/saga';
import hasUnexplainedPayments from './hasunexplainedpayment/reducer';
import hasUnexplainedpaymentsSaga from './hasunexplainedpayment/saga';
import administrativeFines from './administrativeFines/reducer';
import administrativeFinesSaga from './administrativeFines/saga';
import selfInsuranceTaxesReducer from './selfInsuranceTaxes/reducer';
import selfInsuranceTaxesSaga from './selfInsuranceTaxes/saga';
import hasUnitsReducer from './hasUnits/reducer';
import hasUnitsSaga from './hasUnits/saga';

export const newTaxesReducers = {
  taxes: taxesReducer,
  operationsHistory: operationsHistoryReducer,
  operationsHistoryListFilters: operationsHistoryListFiltersReducer,
  pdfInfo: pdfInfoReduser,
  payment: paymentReducer,
  liteObjects: liteObjectsReducer,
  judicialActs: judicialActsReducer,
  unexplainedPayments,
  hasUnexplainedPayments,
  administrativeFines,
  selfInsuranceTaxes: selfInsuranceTaxesReducer,
  hasUnits: hasUnitsReducer,
};

export function* newTaxesSagas() {
  yield all(
    [
      taxesSaga,
      operationsHistorySaga,
      liteObjectsSaga,
      pdfInfoSaga,
      judicialActsSaga,
      unexplainedPaymentsSaga,
      hasUnexplainedpaymentsSaga,
      administrativeFinesSaga,
      selfInsuranceTaxesSaga,
      hasUnitsSaga,
    ].map(fork),
  );
}
